export const environment = {
	production: false,
	msal: {
		clientId: '31b225e1-0365-4556-a869-65735a384d40',
		logoutUri: 'https://acc.steamleaks.xom.cloud',
		redirectUri: 'https://acc.steamleaks.xom.cloud/callback',
		authority: 'https://xomapps.b2clogin.com/tfp/xomapps.onmicrosoft.com/B2C_1A_signin',
		apiScopes: ['https://xomapps.onmicrosoft.com/c92c881a-3441-4371-9bef-95a9f24df4d3/steamleaks-acc/Read'],
		b2cScopes: ['openid', 'https://xomapps.onmicrosoft.com/c92c881a-3441-4371-9bef-95a9f24df4d3/steamleaks-acc/Read'],
		knownAuthorities: ['https://xomapps.b2clogin.com/xomapps.onmicrosoft.com/'],
		exxonSSODomainHint: 'ExxonMobilAADSSO',
		pingDomainHint: 'ExxonMobilPingFedSAML',
	},
	apiUrl: 'https://api-acc.steamleaks.xom.cloud/api/'
};
